// Respondent Progress Channel subscription helper
// Usage: import and call createRespondentProgressSubscription(userId, callback)
import consumer from "./consumer"

export function createRespondentProgressSubscription(userId, callback) {
  if (!userId) return null;
  return consumer.subscriptions.create({ channel: "RespondentProgressChannel", user_id: userId }, {
    received(data) {
      if (data?.type === 'progress') {
        callback && callback(data);
      }
    }
  })
}
